export const FETCH_ENTRY_REQUEST = 'FETCH_ENTRY_REQUEST';
export const FETCH_ENTRY_SUCCESS = 'FETCH_ENTRY_SUCCESS';
export const FETCH_ENTRY_FAILURE = 'FETCH_ENTRY_FAILURE';